import { formatTicker } from '@toggle/toggle';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { AssetLogoContainer } from '~/components/asset-logo-container/AssetLogoContainer';
import { useNavigateToAssetOverview } from '~/hooks/use-navigate-to-asset-overview/useNavigateToAssetOverview';
import { RatingPill } from '~/widgets/earnings-insight-drawer/earnings-insight-widget/components/rating-pill/RatingPill';

import { PriceChange } from '../PriceChange';
import { CompanyCardProps } from './company-card-types';
import styles from './CompanyCard.module.scss';

export const SecondaryCompanyCard = ({
  company,
  entity,
  referenceDate,
  hideRelationship = false,
}: CompanyCardProps) => {
  const { t } = useTranslation(['earnings']);
  const { navigateToPage } = useNavigateToAssetOverview();

  return (
    <div
      className={styles.root}
      onClick={() => navigateToPage({ entityTag: company.entity_tag })}
    >
      <div className={styles.headerWrapper}>
        <div
          className={styles.assetDetailsWrapper}
          onClick={() => navigateToPage({ entityTag: company.entity_tag })}
        >
          <AssetLogoContainer size={40} entity={entity} />
          <div className={styles.assetNameWrapper}>
            <span className={styles.assetNameLabel}>
              {entity.name_short || entity.name}
            </span>
            <span className={styles.flexWrapper}>
              <span className={styles.assetTickerLabel}>
                {formatTicker(entity)}
              </span>
              <PriceChange companyData={entity} referenceDate={referenceDate} />
            </span>
          </div>
        </div>
        <RatingPill rating={company.rating} />
      </div>
      <div className={styles.descriptionLabel}>{company.description}</div>
      {!hideRelationship && company.relationship && (
        <div className={styles.relationLabel}>{`${t(
          'earnings:earningsInsight.drawer.earningsPreview.relationship'
        )} ${company.relationship}`}</div>
      )}
    </div>
  );
};
